export default "__VITE_ASSET__BHnhk8No__"